<template>
    <div class="collection">
        <header>
            <div class="container">
                <div class="header__top">
                    <div class="header__top--left">
                        <div class="collection__logo" width="128" height="128">
                            <svg width="64px" height="64px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="icons-/-filled-/-Heart" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <path d="M12,6.04168892 C9.33165018,-0.396099541 1,1.2374529 1,8.24936117 C1,9.44662657 1.42522258,10.7488894 2.21745959,12.1427661 C3.16055591,13.8020676 4.5996091,15.5528036 6.4023296,17.3429285 C7.56530417,18.4977774 8.80980511,19.5999935 10.0542382,20.6130947 C10.4898251,20.9677088 10.8944894,21.2860107 11.2579947,21.5633617 C11.4769961,21.7304577 11.6342722,21.8472421 11.7195736,21.9090561 C11.8869068,22.0303146 12.1130932,22.0303146 12.2804264,21.9090561 C12.3657278,21.8472421 12.5230039,21.7304577 12.7420053,21.5633617 C13.1055106,21.2860107 13.5101749,20.9677088 13.9457618,20.6130947 C15.1901949,19.5999935 16.4346958,18.4977774 17.5976704,17.3429285 C19.4003909,15.5528036 20.8394441,13.8020676 21.7825404,12.1427661 C22.5747774,10.7488894 23,9.44662657 23,8.24936117 C23,1.2374529 14.6683498,-0.396099541 12,6.04168892 Z" id="Path" fill="#FFFFFF"></path>
                                </g>
                            </svg>
                        </div>
                        <div class="header__left--meta">
                            <h1>{{$t('page.collection.title')}}</h1>
                            <span v-if="highlightedPlugins" class="items">{{Object.keys(highlightedPlugins).length}} {{$t('page.collection.x_items')}}</span>
                        </div>
                    </div>
                    <div class="header__top--right">
                        <a v-if="false" class="highlight__plugin">
                            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="icons-/-line-/-info" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <path d="M11.9907834,0 C18.562212,0 24,5.42857143 24,12 C24,18.5714286 18.5714286,24 12,24 C5.42857143,24 0,18.5714286 0,12 C0,5.42857143 5.41935484,0 11.9907834,0 Z M11.9858667,1.5 C6.15933933,1.5 1.5,6.18548387 1.5,12 C1.5,17.8145161 6.16875213,22.5 11.9952795,22.5 C17.812394,22.5 22.5093846,17.8145161 22.5,12 C22.490559,6.18548387 17.8029812,1.5 11.9858667,1.5 Z M12.3041475,9.89631336 C12.7772657,9.89631336 13.030722,10.234255 13.030722,10.7242704 L13.030722,16.6382488 L14.5176651,16.6382488 C14.906298,16.6382488 15.2019969,16.9254992 15.2019969,17.297235 C15.2019969,17.6774194 14.906298,17.9646697 14.5176651,17.9646697 L10.0652842,17.9646697 C9.67665131,17.9646697 9.37250384,17.6774194 9.37250384,17.297235 C9.37250384,16.9254992 9.67665131,16.6382488 10.0652842,16.6382488 L11.5522273,16.6382488 L11.5522273,11.2227343 L10.2173579,11.2227343 C9.83717358,11.2227343 9.53302611,10.9354839 9.53302611,10.5552995 C9.53302611,10.1920123 9.83717358,9.89631336 10.2173579,9.89631336 L12.3041475,9.89631336 Z M11.9239631,5.41013825 C12.6420891,5.41013825 13.1996928,5.97619048 13.1996928,6.69431644 C13.1996928,7.40399386 12.6420891,7.97004608 11.9239631,7.97004608 C11.2142857,7.97004608 10.6397849,7.40399386 10.6397849,6.69431644 C10.6397849,5.97619048 11.2142857,5.41013825 11.9239631,5.41013825 Z" id="Combined-Shape" fill="#575C61"></path>
                                </g>
                            </svg>
                            <span class="highlight__info">{{$t('page.collection.notifications_text')}}</span>
                        </a>
                        <btn v-if="$store.state.userData && !$store.state.userData.notifications && false" @click="toggleNotifications()" :class="'btn--ghost'" :text="$t('page.collection.notifications_on')" />
                        <btn v-if="$store.state.userData && $store.state.userData.notifications && false" @click="toggleNotifications()" :class="'btn--ghost'" :text="$t('page.collection.notifications_off')" />
                    </div>
                </div>
                <div class="header__bottom">
                </div>
            </div>
        </header>
        <main>
            <div class="container">
                <div class="plugin__grid plugin__grid--minified">
                    <plugin-entry
                        v-for="plugin in highlightedPlugins" 
                        :key="plugin.id"
                        :id="plugin.id"
                        :logo="plugin.image"
                        :size="96"
                        :title="plugin.name"
                        :short_description="plugin.short_description"
                        :technologies="plugin.technologies"
                        :brands="plugin.brands"
                        :rating="plugin.rating"
                        :creator="plugin.creator"
                        :highlight="plugin.highlight"
                        :certified="plugin.certified"
                        :type="plugin.type"></plugin-entry>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import axios from 'axios';
import PluginEntry from '@/components/PluginEntry.vue';
import Btn from '@/components/Button.vue';

export default {
    components: {
        PluginEntry,
        Btn
},
data() {
    return {
        highlightedPlugins: null,
        highlightedPluginsFilter: {
            highlight: '1',
        },
        accountData: null,
    }
},

    methods: {
        toggleNotifications() {
            var formData = new FormData();
            formData.append('status', this.$store.state.userData.notifications);

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/toggleNotifications',
                data: formData
            }).then(response => {
                this.$store.state.userData.notifications = response.data.status;

                if(this.$store.state.userData.notifications == 1) {
                    this.$store.dispatch('addNotification', {title: 'Notifications activated.', type: 'success'});
                } else {
                    this.$store.dispatch('addNotification', {title: 'Notifications deactivated.', type: 'success'});
                }
            });
        }
    },

created() {
        //Get Highlighted Plugins
        var highlightedPlugins = new FormData();
        highlightedPlugins.append('filter', JSON.stringify(this.highlightedPluginsFilter));
        highlightedPlugins.append('orderby', 'plugin_downloads');
        highlightedPlugins.append('order', 'DESC');
        highlightedPlugins.append('limit', '0,15');
        highlightedPlugins.append('isFiltered', 'true');
        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadFilteredPlugins',
            data: highlightedPlugins,
        }).then(response => (this.highlightedPlugins = response.data));

        //Get User Data
        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/loadAccountDetail',
        }).then(response => {
            this.accountData = response.data;
        });
    },
}
</script>

<style scoped>
    .plugin__grid{
        padding: 0 20px;
    }
header{
    padding-top: 50px;
    border-bottom: 1px solid #E6E6E6;
}
    main{
        background: #F9F9F9;
        padding: 40px 0;
    }
    
    .header__top{
        display: flex;
        justify-content: space-between;
        padding-bottom: 40px;
    }

    .header__top--left{
        display: flex;
        justify-content: space-between;
        vertical-align: top;
    }
    .header__left--meta{
        vertical-align: top;
        padding-left: 30px;
    }

    .header__left--meta h1{
        margin-top: 0;
        font-weight: bold;
        font-size: 50px;
        line-height: 56px;
        margin-bottom: 10px;
    }

    .header__left--meta span{
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
        margin-right: 50px;
    }

    .header__left--meta span a{
        color: #E73246;
    }
    .highlight__plugin{
        width: 42px;
        height: 42px;
        display: inline-block;
        vertical-align: top;
        padding: 10px 9px;
        box-sizing: border-box;
    position: relative;
    }

.highlight__info{
    font-size: 14px;
    color: #575C61;
    line-height: 20px;
    position: absolute;
    right: 20px;
    top: 20px;
    padding: 10px 15px;
    background-color: #F5F5F5;
    box-shadow: 0px 2px 8px rgba(0,0,0,0.25);
    width: 260px;
    box-sizing: border-box;
    display: none;
}
.highlight__plugin:hover .highlight__info{
    display: block;
}
    .plugin__grid{
        display: grid;
        grid-template-columns: calc(calc(100% / 3) - calc(50px / 3)) calc(calc(100% / 3) - calc(50px / 3)) calc(calc(100% / 3) - calc(50px / 3));
        grid-column-gap: 25px;
        grid-row-gap: 25px;
        
        max-width: 910px;
        margin: 0 auto;
    }
    .collection__logo{
        background-color: #E73246;
        display: inline-block;
        width: 128px;
        height: 128px;
        padding: 32px;
        box-sizing: border-box;
    }
</style>